/********
  * COMPONENT: USE THIS SERVICE TO MANAGE SYSTEM AUTHENTICATION - 
    #. LOGIN.
      #. LOCAL STORAGE.
        #. USER ROLES.
        #. USER INFORMATION.
        #. SYSTEM TRANSLATIONS STRING.
    #. LOGOUT.
      #. REMOVE LOCAL STORAGE.
        #. USER ROLES.
        #. USER INFORMATION.
        #. TRANSLATIONS STRING.
    #. SET/RESET PASSWORD.
    #. SEND EMAIL ON RESET PASSWORD.
    #. LOGIN USER INFORMATIONS.
    #. REGISTER USER.
    #. .... .... .... ....
  * @AUTHOR: IMPRESSICO(fb/gshukla67).
  * DATE: 22/01/2018.
  * UPDATE: --/--/----.
*/
import { Injectable, NgZone, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
//import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FacebookService, InitParams, LoginOptions, LoginResponse } from 'ngx-facebook';
import { AuthService } from 'angular2-google-login';

import { HttpService } from './http.service';
import { Constants } from '../app.constant';
import { User } from '../models';
import { PushNotificationService } from '../../app/pages/shared/services/push-notification.service'
import { EncryptionService } from './encryption.service';
@Injectable()
export class AuthenticationService extends HttpService {

  public response;
  public user: User;
  public token: string;
  public customer: any[];
  private pushNotiService: PushNotificationService
  private encryptionService = new EncryptionService();

  // private loggedIn = new BehaviorSubject<boolean>(false);

  // get isLoggedIn() {
  //   return this.loggedIn.asObservable();
  // }

  /*
  constructor(
    public http: Http,
    private zone: NgZone,
    private fb: FacebookService,
    private _googleAuth: AuthService
  ) {
    super(http);
    let initParams: InitParams = {
    appId: '279979445831462', // Facebook.
    xfbml: true,
    cookie: true,
    version: 'v2.10'
    };
    fb.init(initParams);
  }
  */

  public login(email: string, password: string, tempPwd: string,captchaToken?): Observable<boolean> {
    let requestOptionsArgs = { body: { email: email, password: password,reCaptchaClientResponse: captchaToken, reCaptchaClientRemoteIp:'' } };
    let mokeString = (email == "a@a.com") ? "auth-super" : "auth-customer";
    return this.postApi('/login', requestOptionsArgs, mokeString)
      .map(res => {
        this.response = res.json() && res.json().result;
        let token = this.response.token;
        let customerId = this.response.customerId;
        
        if (token) {
          this.token = token;
          let user = <User>this.response.user;
          let customer = this.response.user.customer;
          this.user = user;
          delete this.user.customer;
          let rabbitUsername = this.response.rabbitUsername ? this.response.rabbitUsername : null;
          let rabbitMqServerUrl = this.response.rabbitMqServerUrl ? this.response.rabbitMqServerUrl : null;
         
          this.encryptionService.saveData('currentUser',{ user: this.user, token: this.token });  // Encrypt data
          this.customer = customer;
          this.encryptionService.saveData('currentCustomer',{ customer: this.customer });  // Encrypt data
         // this.loggedIn.next(true);
          this.encryptionService.saveData('currentStompConfig', {
            'url': 'ws://' + rabbitMqServerUrl + ':15674/ws',
            'loginName': rabbitUsername,
            'passcode': tempPwd
          })     
          return true;
        } else {
          return false;
        }
      })
      .flatMap(res => {
        let mokeString: string;
        let requestOptionsArgs: any = {};
        let usrInfo = this.getlogedinUser();
        if (usrInfo && usrInfo.roles && usrInfo.roles[0] && usrInfo.roles[0].roleId) {
          mokeString = (usrInfo.userType == 'SUPER') ? "auth-role-super" : "auth-role-customer";
        } else {
          mokeString = (usrInfo.userType == 'SUPER') ? "auth-role-super" : "auth-role-customer";
        }
        return this.getApi('/role/my-role', requestOptionsArgs, mokeString)
          .map(role => {
            let authRl = role.json() && role.json().result;
            localStorage.setItem('authorizedRole', JSON.stringify({ role: authRl }));
            return true;
          });
      })
      .flatMap(res => {
        let requestOptionsArgs = { body: { lang: "en" } };
        return this.getApi('/localization' + '?language=en', requestOptionsArgs, 'translate-strings', false)
          .map(tran => {
            let str = tran.json() && tran.json().result;
            localStorage.setItem('translateStr', JSON.stringify({ tstring: str }));
            return true;
          });
      })
      .flatMap(res => {
        let requestOptionsArgs = {};
        return this.getApi('/push/web/keys', requestOptionsArgs, 'notification-keys')
          .map(tran => {
            let keys = tran.json() && tran.json().result;
            localStorage.setItem('notificationKeys', JSON.stringify({ keys: keys }));
            return true;
          });
      })
      .flatMap(res => {
        let requestOptionsArgs = {};
        return this.getApi('/pan-config', requestOptionsArgs, 'app-setting')
          .map(tran => {
            let keys = tran.json() && tran.json().result;
            localStorage.setItem('appConfiguration', JSON.stringify({ keys: keys }));
            return true;
          });
      })
      .flatMap(res => {
        let requestOptionsArgs = {};
        return this.getApi('/advertisement/enabled', requestOptionsArgs, 'app-setting')
          .map(tran => {
            let keys = tran.json() && tran.json().result;
            localStorage.setItem('PDNAccess', JSON.stringify({ keys: keys }));
            return true;
          });
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public logout(): Observable<any> {
    this.token = this.user = null;
    let oldToken = Constants.CurrentFirebaseInformations('token')
    // this.loggedIn.next(false);
    let requestOptionsArgs = (oldToken) ? { body: { registrationId: oldToken } } : {};
    return this.postApi('/logout', requestOptionsArgs, "logout")
      .map(res => {
        Constants.resetVariables(true);
        localStorage.removeItem('currentUser');
        localStorage.removeItem('translateStr');
        localStorage.removeItem('firebaseInfo');
        localStorage.removeItem('authorizedRole');
        localStorage.removeItem('currentCustomer');
        localStorage.removeItem('notificationKeys');
        localStorage.removeItem('appConfiguration');
        localStorage.removeItem('PDNAccess');
        localStorage.removeItem('ageGroupEnums');
        localStorage.removeItem('currentStompConfig');
        if(!Constants.Var.sslOn){
          this.pushNotiService.unsubscribe();
        }  
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public register(fname: string, lname: string, email: string, mobile: string, password: string): Observable<boolean> {
    let requestOptionsArgs = { body: { fname: fname, lname: lname, email: email, mobile: mobile, password: password } };
    return this.postApi('/customer/register', requestOptionsArgs, 'register')
      .map(res => {
        let user = <User>res.json() && res.json().user;
        this.user = user;
        return true;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public sendEmailToResetPwd(email: string): Observable<boolean> {
    const requestOptionsArgs = { body: { 'email': email } };
    return this.postApi('/password-forgot', requestOptionsArgs, 'password-forgot')
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public forgetPassword(email: string): Observable<boolean> {
    const requestOptionsArgs = { body: { 'email': email } };
    return this.postApi('/password-forgot?email-type=resend-set-password', requestOptionsArgs, 'password-forgot')
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public setPassword(password: string, token: string): Observable<boolean> {
    const requestOptionsArgs = { body: { 'password': password, 'emailToken': token } };
    return this.postApi('/password', requestOptionsArgs, 'register')
      .map(res => {
        return true;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

    public setUserPassword(password: string, userId): Observable<boolean> {
        const requestOptionsArgs = { body: { 'password': password } };
        return this.postApi(`/user-password/${userId}`, requestOptionsArgs, 'register')
          .map(res => {
            return true;
          })
          .catch((e) => Observable.throw(this.errorHandler(e)));
      }

  public getlogedinUser() {
    var currentUser = this.encryptionService.getData('currentUser');
    return (currentUser && currentUser.user || null);
  }

  public getData() {
    return {
      token: localStorage.getItem('token'),
      imageURL: localStorage.getItem('image'),
      name: localStorage.getItem('name'),
      email: localStorage.getItem('email'),
    };
  }

  public getNonLoginBrandingData(_val){
    let requestOptionsArgs = {search: { 'origin': _val }};
    return this.getApi('/customer/branding/non-logged-in', requestOptionsArgs, 'app-setting', false)
      .map(res => {
        let keys = res.json() && res.json().result;
        // localStorage.setItem('PDNAccess', JSON.stringify({ keys: keys }));
        return keys;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts